import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';

interface SensorEquipmentFieldsProps {
  manufacturer: string;
  model: string;
  serialnumber: string;
  onChange: (field: string, value: string) => void;
}

export function SensorEquipmentFields({
  manufacturer,
  model,
  serialnumber,
  onChange,
}: SensorEquipmentFieldsProps) {
  const [open, setOpen] = useState(false);

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger className="flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground w-full py-1">
        <ChevronRight
          className={`h-4 w-4 transition-transform ${open ? 'rotate-90' : ''}`}
        />
        Equipment
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-3 pt-2 pl-5">
        <div>
          <Label htmlFor="sensor-manufacturer">Manufacturer</Label>
          <Input
            id="sensor-manufacturer"
            value={manufacturer}
            onChange={(e) => onChange('manufacturer', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="sensor-model">Model</Label>
          <Input
            id="sensor-model"
            value={model}
            onChange={(e) => onChange('model', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="sensor-serialnumber">Serial Number</Label>
          <Input
            id="sensor-serialnumber"
            value={serialnumber}
            onChange={(e) => onChange('serialnumber', e.target.value)}
          />
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
